import React, { useState } from "react";
import LeaveTypeTable from "./components/LeaveTypeTable";
import LeaveTypeAddEditModal from "./components/LeaveTypeAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';

// MODIFIED: Receives hook data/functions as props from LeaveTypePage
const LeaveTypeModule = ({
  user,
  data,
  loading,
  taxTreatmentsEnum,
  searchData,
  createLeaveType,
  updateLeaveType,
  isAdminMode = false
}) => {
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (form) => {
    const apiData = {
      ...form,
      // MODIFIED: taxExemptLimit is forced to Integer, maxEncashableDays remains Decimal
      taxExemptLimit: form.taxExemptLimit === "" ? 0 : Math.floor(Number(form.taxExemptLimit)),
      maxEncashableDays: form.maxEncashableDays === "" ? 0 : Number(form.maxEncashableDays),
      taxTreatment: Number(form.taxTreatment)
    };

    if (selectedItem) {
      const audit = [{
        setupArea: "Leave Type",
        actionTaken: "update",
        field: "Description",
        newValue: apiData.description,
        oldValue: selectedItem.description,
        dateSaved: new Date(),
        savedById: user.id
      }];

      const res = await updateLeaveType(selectedItem.id, apiData, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Leave Type",
        actionTaken: "insert",
        field: "Add",
        newValue: apiData.description,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createLeaveType(apiData, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<AddIcon />}
          name={"Add Leave Type"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <LeaveTypeTable
        data={data}
        onEdit={handleEdit}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <LeaveTypeAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
        taxTreatmentsEnum={taxTreatmentsEnum}
        isAdminMode={isAdminMode}
        data={data}
      />
    </div>
  );
};

export default LeaveTypeModule;